import React from 'react';
const teamMembers = [{
  name: 'Mathieu Stoffels',
  role: 'Entrepreneur',
  bio: "Expert en revalorisations des terres d'excavation",
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/77Rod7K9HvsKDeTMZDjpqp/image.png'
}, {
  name: 'Tullia Bousquet',
  role: 'Architecte',
  bio: 'Spécialiste en architecture bioclimatique',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kZKJHLnMS4jCRkvsd17iY4/image.png'
}, {
  name: 'Pierre Orjebin',
  role: 'Ingénieur R&D',
  bio: 'Spécialiste des matériaux et procédés innovants',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fZymfSDHLv2xk6H7N6hTmT/image.png'
}, {
  name: 'Laurie Metais',
  role: 'Architecte',
  bio: 'Spécialiste du réemploi et de la sensibilisation',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mQYQEx2T6WYFpBDn2gFZST/image.png'
}, {
  name: 'Manuel Letort',
  role: 'Entrepreneur',
  bio: 'Expert en tech & innovation durable',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rsvM2bY3TfC5Dv914QjApn/image.png'
}];
export function TeamSection() {
  return <section id="team" className="py-20 bg-[#f5f1e8]" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="text-center mb-16" data-id="element-122">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-123">
            L'équipe Materrea
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-124">
            Des experts passionnés qui œuvrent pour transformer l'industrie de
            la construction
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 lg:gap-6" data-id="element-125">
          {teamMembers.map((member, index) => <div key={index} className="bg-white rounded-xl overflow-hidden shadow-md transition-transform duration-300 hover:transform hover:scale-105" data-id="element-126">
              <div className="h-32 sm:h-36 relative overflow-hidden" data-id="element-127">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover object-top" data-id="element-128" />
              </div>
              <div className="p-3 sm:p-4" data-id="element-129">
                <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-1" data-id="element-130">
                  {member.name}
                </h3>
                <p className="text-[#8d6e4b] text-sm font-medium mb-1" data-id="element-131">
                  {member.role}
                </p>
                <p className="text-gray-600 text-xs sm:text-sm" data-id="element-132">{member.bio}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}